<template>
    <view-visualization>
        <template #reservoir-info="{ reservoirInfo: data }">
            <b-form-group label="Cota montante">
                <b-input-group append="m">
                    <swx-number-input
                        :value="data.quota_flux"
                        name="quota_flux"
                        disabled
                    />
                </b-input-group>
            </b-form-group>
        </template>
    </view-visualization>
</template>
<script>
import ViewVisualization from "@/modules/common/views/ViewVisualization";
import SwxNumberInput from "@/components/SwxNumberInput";

export default {
    name: "Visualization",
    components: {
        ViewVisualization,
        SwxNumberInput
    }
};
</script>
